export const recordReasoningFinish = (
  outcomes,
  { message, isAbort, isError, isDisconnect } = {},
) => {
  if (!message?.id || message.role !== 'assistant') {
    return outcomes;
  }
  let interruption;
  if (isAbort) {
    interruption = 'cancelled';
  } else if (isError || isDisconnect) {
    interruption = 'error';
  }
  if (!interruption && !outcomes.has(message.id)) {
    return outcomes;
  }
  const next = new Map(outcomes);
  if (interruption) {
    next.set(
      message.id,
      (message.parts || [])
        .filter((part) => part.type === 'reasoning')
        .map((part) => {
          if (part.state === 'done') return 'complete';
          return part.state === 'streaming' ? interruption : undefined;
        }),
    );
  } else {
    next.delete(message.id);
  }
  return next;
};

// The adapter filters non-rendered parts (for example step-start), but preserves reasoning order.
export const getReasoningPartIndex = (parts, partIndex) =>
  parts.slice(0, partIndex).filter((part) => part.type === 'reasoning').length;

export const getReasoningState = (status, expanded, finishOutcome) => {
  const isComplete = finishOutcome === 'complete';
  const isInterrupted = !isComplete && (Boolean(finishOutcome) || status?.type === 'incomplete');
  const isRunning =
    !isComplete && !isInterrupted && (status?.type === 'running' || status?.type === 'reasoning');
  let title = '思考过程';
  if (isRunning) {
    title = '思考中...';
  } else if (isInterrupted) {
    title = (finishOutcome || status.reason) === 'cancelled' ? '思考已停止' : '思考中断';
  }
  return {
    expanded: expanded ?? (isRunning || isInterrupted),
    isRunning,
    title,
  };
};
